// @flow
import type { Action } from 'app/common/redux/types';

export type State = {
  showNewsHubDropdown: boolean,
  showConversationsDropdown: boolean,
  badgeCounts: {
    conversationsUnseenCount: number,
    newsHubCount: number,
  },
};

const initialState = {
  showNewsHubDropdown: false,
  showConversationsDropdown: false,
  badgeCounts: {
    newsHubCount: 0,
    conversationsUnseenCount: 0,
  },
};

const notifications = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'CLOSE_NOTIFICATIONS_DROPDOWN':
      return { ...state, showNewsHubDropdown: false };
    case 'OPEN_NOTIFICATIONS_DROPDOWN':
      return { ...state, showNewsHubDropdown: true };
    case 'CLOSE_CONVERSATIONS_DROPDOWN':
      return { ...state, showConversationsDropdown: false };
    case 'OPEN_CONVERSATIONS_DROPDOWN':
      return { ...state, showConversationsDropdown: true };
    case 'UPDATE_BADGE_COUNT':
      return { ...state, badgeCounts: action.payload };
    case 'CONVERSATION_BADGE_RESET':
      return {
        ...state,
        badgeCounts: {
          ...state.badgeCounts,
          conversationsUnseenCount: 0,
        },
      };
    default:
      return state;
  }
};

export default notifications;
